import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { RegistationUtilitiesService } from '../../services/registation-utilities.service';
import { BehaviorSubject, combineLatest, Observable, of, Subject, } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatAutocompleteSelectedEvent, MatOption } from '@angular/material/autocomplete';
import {
  addressValidationValidator,
  noHtmlTagsValidator,
} from 'src/app/shared/Validators/special-character-validation';
import { AuthServiceService } from 'src/app/services/authService/auth-service.service';
import { ApiService } from 'src/app/services/apiService/api.service';
import { StepperService } from 'src/app/services/stepperService/stepper.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { DataLayerService } from 'src/app/services/dataLayer/datalayer.service';
import { SignUpContentServiceService } from '../../services/sign-up-content-service.service';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
import { environment } from 'src/environments/environment';
import { NgIf, NgStyle, NgFor, NgClass, CommonModule } from '@angular/common';
import { MatFormField, MatLabel, MatError, MatSuffix, MatFormFieldModule } from '@angular/material/form-field';
import { MatInput, MatInputModule } from '@angular/material/input';
import { NgSelectComponent, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgLabelTemplateDirective, NgNotFoundTemplateDirective } from '@ng-select/ng-select';
import { AutoBlurSelectDirective } from '../../../../shared/directive/auto-select-blur.directive';
import { MatIcon } from '@angular/material/icon';
import { MatSelect } from '@angular/material/select';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatButton } from '@angular/material/button';

// demo code start
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { startWith, map } from 'rxjs';
interface Country1 {
  name: string;
  code: string;
  flag: string;
}
interface Food {
  value: string;
  viewValue: string;
}
// demo code end

export interface Country {
  name: string;
  code: string;
}
export interface StateGroup {
  letter: string;
  names: {
    name: string;
    code: string;
    isdCode: string;
    countryFlag: string;
  }[];
}
export interface State {
  name: string;
  code: string;
}
export interface City {
  cityName: string;
  cityCode: string;
}
export const _filter = (
  opt: { name: string; code: string }[],
  value: string,
): { name: string; code: string }[] => {
  const filterValue = value.toLowerCase();
  return opt.filter((item) => item.name.toLowerCase().includes(filterValue));
};

@Component({
    selector: 'app-corporate-info',
    templateUrl: './corporate-info.component.html',
    styleUrls: ['./corporate-info.component.scss'],
    imports: [CommonModule, MatSelectModule, MatAutocompleteModule, MatInputModule,
    MatFormFieldModule,NgIf, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatError, NgSelectComponent, AutoBlurSelectDirective, MatIcon, MatSuffix, NgStyle, MatSelect, NgFor, MatOption, NgClass, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgLabelTemplateDirective, NgNotFoundTemplateDirective, MatRadioGroup, MatRadioButton, MatButton]
})
export class CorporateInfoComponent implements OnInit, OnDestroy {
  // demo code start
  foods: Food[] = [
    {value: 'steak-0', viewValue: 'Steak'},
    {value: 'pizza-1', viewValue: 'Pizza'},
    {value: 'tacos-2', viewValue: 'Tacos'},
  ];
  agencies: string[] = [
    'M Corporate Agency',
    'ABC Travels',
    'XYZ Holidays'
  ];
  
  selectedAgencies: string[] = ['M Corporate Agency'];

  removeAgency(agency: string): void {
    this.selectedAgencies = this.selectedAgencies.filter(
      item => item !== agency
    );
  }

  countryCtrl = new FormControl<string | Country1>('');

  countries1: Country1[] = [
    {
      name: 'U.S. Minor Outlying Islands',
      code: '+1',
      flag: 'assets/flags/us.png'
    },
    {
      name: 'Uganda',
      code: '+234',
      flag: 'assets/flags/uganda.png'
    }
  ];

  filteredCountries1!: Observable<Country1[]>;


  displayCountry(country: Country1): string {
    return country ? country.name : '';
  }
  // demo code end
  
  @Output() CorporateInfo = new EventEmitter<any>();
  @Output() editClicked = new EventEmitter<void>();
  @Input() EditLink: boolean = false;
  @Input() showForm: boolean = true;
  @Input() CorporateHeading: boolean = true;
  content: any;
  corporateForm!: FormGroup;
  isCityDirty = false;
  noResultsFound = false;
  countries: any[] = [];
  filteredCountries: any;
  cityControl = new FormControl('');
  filteredCities: { cityName: string; cityCode: string }[] = [];
  selectedCity: any;
  PreviousCity: string = '';
  PreviousCityCode: string = 'SA';
  PreviousCountry: string = '';
  PreviousCountryCode: string = '';
  Shub = false;
  submittedData: any;
  countriesLists: any[] = [];
  message: any;
  filteredcountries1: any;
  private readonly destroy$ = new Subject<void>();
  getViewValue(value: string, options: any[]): string {
    const option = options.find((opt) => opt.Phrase === value);
    return option ? option.Phrase : '-';
  }
  displayFnn(option: { name: string; code: string } | null): string {
    return option ? option.name : '';
  }
  stateForm = this.fb.group({
    stateGroup: [null, Validators.required],
  });
  stateGroupOptions: Observable<StateGroup[]> = new Observable<StateGroup[]>();
  private readonly stateGroupSubject: BehaviorSubject<StateGroup[]> =
    new BehaviorSubject<StateGroup[]>([]);
  dictionaryContent: any;
  newCustomCountries: any[] = [];
  public _siteCoreBaseUrl = environment.siteCoreBaseUrl;
  constructor(
    private readonly _StepperService: StepperService,
    private readonly fb: FormBuilder,
    public readonly _ApiService: ApiService,
    private readonly registrationUtility: RegistationUtilitiesService,
    private readonly authService: AuthServiceService,
    public readonly _CommonService: CommonService,
    private readonly _DataLayerService: DataLayerService,
    private readonly contentService: SignUpContentServiceService,
    private readonly dictionaryContentService: DisctionaryContent,
  ) {
    this.stateGroupOptions = this.stateGroupSubject.asObservable();
    this.corporateForm = this.fb.group({
      companyName: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(150), Validators.pattern('^[A-Za-z0-9&. ]*$'),],], // noHtmlTagsValidator(),
      natureOfBusiness: [null, [Validators.required, Validators.maxLength(200)],],
      numberOfEmployee: ['', [Validators.required]],
      stateGroup: ['', [noHtmlTagsValidator()]],
      registrationId: ['', [Validators.minLength(8), Validators.maxLength(15)]],
      PostalCode: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(10),],],
      cityControl: ['', []], // city: [null, [Validators.required]],
      city: [null, Validators.required],
      district: [''],
      BuildingNo: [''],
      headOfficeAddress: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(150), addressValidationValidator(),],],
      companyUrl: ['', [Validators.minLength(5), Validators.maxLength(200), Validators.pattern(/^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/.*)?$/,),],],
      AnnualBudget: ['', [Validators.required, Validators.maxLength(20)]],
      hasCompanyDomain: [true, []],
      domainName: ['', [Validators.maxLength(100), Validators.pattern(/^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/),],],
      taxIdentifcationNo: [''],
    });
  }
  ngOnInit() {
    combineLatest({
      content: this.contentService.content$,
      dictionary: this.dictionaryContentService.content$,
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        console.log('response of forkJoin', res);
        this.content = {
          ...res.content,
          dictionary: res.dictionary,
        };
      });
    this._StepperService.RegstrationStepper('Corporate');
    window.scrollTo(0, 0);
    this._ApiService
      .getCountriesData()
      .then(($res) => {
        this.newCustomCountries =
          this._CommonService.groupCountriesFilter($res);
      })
      .catch(($err) => { });
    this.corporateForm
      .get('hasCompanyDomain')
      ?.valueChanges.subscribe((value) => {
        const domainControl = this.corporateForm.get('domainName');
        if (value === true) {
          // If Yes is selected, make domainName required
          domainControl?.setValidators([
            Validators.required,
            Validators.maxLength(100),
            Validators.pattern(/^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/),
          ]);
        } else {
          // If No is selected, remove required validator
          domainControl?.setValidators([
            Validators.maxLength(100),
            Validators.pattern(/^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/),
          ]);
          domainControl?.setValue(''); // Clear the value
          domainControl?.setErrors(null); // Clear errors
        }
        domainControl?.updateValueAndValidity();
      });
    this.stateForm.get('stateGroup')?.valueChanges.subscribe((value: any) => {

      if (value) {
        this.Setcity(value, '');
        this.PreviousCountry = value;
        this.corporateForm.get('city')?.setValue(null);
        this.corporateForm.get('cityControl')?.setValue(null);
        this.updateRegistrationIdValidators(value);

        // 🔥 CALL COMPANY CHECK IF COMPANY NAME EXISTS
        const companyName = this.corporateForm.get('companyName')?.value?.trim();

        if (companyName && companyName.length >= 4) {
          this.performCompanyCheck(companyName, value, 'NAME');
        }

        const registrationId = this.corporateForm.get('registrationId')?.value?.trim();
        if (registrationId && registrationId.length >= 8) {
          this.performCompanyCheck(registrationId, value, 'REGISTRATIONID');
        }

        const taxId = this.corporateForm.get('taxIdentifcationNo')?.value?.trim();
        if (taxId && taxId.length >= 8) {
          this.performCompanyCheck(taxId, value, 'TAX');
        }
      }
    });
    // this.setupCompanyCheckDebounce();
    this._DataLayerService.registrationPageLanding('Company Details Page');

    // demo code start 
    this.filteredCountries1 = this.countryCtrl.valueChanges.pipe(
      startWith(''),
      map((value: string | Country1 | null) => {
        const search =
          typeof value === 'string'
            ? value.toLowerCase()
            : value?.name.toLowerCase() ?? '';

        return this.countries1.filter(country =>
          country.name.toLowerCase().includes(search)
        );
      })
    );
    // demo code end
  }

  getImageUrl(path: string): string {
    if (!path) return '';
    const base = this._siteCoreBaseUrl?.replace(/\/+$/, '') || '';
    const cleanPath = path.replace(/^\/+/, '');
    return `${base}/${cleanPath}`;
  }
  filterCountries(value: any): void {
    const searchValue = value?.stateGroup?.toLowerCase()?.trim() || '';
  
    const currentState: any[] = this.countriesLists.filter(
      ($country: any) =>
        $country.countryName?.toLowerCase().includes(searchValue)
    );
  
    this.groupCountries(value?.stateGroup);
    // this.groupCountries(currentState);
  }
  groupCountries(data: any): void {
    if (!this.countriesLists?.length) {
      this.countriesLists = data;
    }
    this.filteredCountries = data;
    const grouped: {
      [key: string]: {
        name: string;
        code: string;
        isdCode: string;
        countryFlag: string;
      }[];
    } = this.filteredCountries?.reduce(
      (acc: any, country: any) => {
        const firstLetter = country.countryName[0].toUpperCase(); // Use countryName instead of Country
        if (!acc[firstLetter]) {
          acc[firstLetter] = [];
        }
        acc[firstLetter].push({
          name: country.countryName,
          code: country.isoCode,
          isdCode: country.code,
          countryFlag: country.newFlag.src,
        });
        return acc;
      },
      {} as {
        [key: string]: {
          name: string;
          code: string;
          isdCode: string;
          countryFlag: string;
        }[];
      },
    );
    if (this.filteredCountries) {
      const sortedGroupLetters = Object.keys(grouped).sort((a, b) =>
        a.localeCompare(b),
      );
      const saudiGroup = grouped['S']?.find((c) => c.name === 'Saudi Arabia');
      if (saudiGroup) {
        grouped['S'] = grouped['S'].filter((c) => c.name !== 'Saudi Arabia');
        grouped['S'] = [
          {
            name: 'Saudi Arabia',
            code: 'SA',
            isdCode: '966',
            countryFlag:
              '/-/media/SaudiaWebApp/data/media/img/Flags/Latest-flags/Flag-saudi_arabia.ashx?rev=856c905ee3344e1295e5948ae4d64d9a',
          },
          ...grouped['S'],
        ];

        const index = sortedGroupLetters.indexOf('S');
        if (index > -1) {
          sortedGroupLetters.splice(index, 1);
        }
        // sortedGroupLetters.unshift('S');
      }
      // Wrap the result in `of()` to make it an Observable
      this.stateGroupOptions = of(
        sortedGroupLetters.map((letter) => {
          return {
            letter: letter,
            names: grouped[letter],
          };
        }),
      );
    }
  }
  onOptionSelected(event: MatAutocompleteSelectedEvent): void {
    this.stateForm.get('stateGroup')?.setValue(event.option.value);
  }
  filterCities(value: string): City[] {
    const filterValue = value.toLowerCase();
    return this.filteredCities.filter((city) =>
      city.cityName.toLowerCase().includes(filterValue),
    );
  }
  getCountryName(
    selectedCountry: { name: string; code: string } | null,
  ): string {
    return selectedCountry ? selectedCountry.name : '-';
  }
  getCountryNameFromCode(code: string | null | undefined): string {
    if (!code || !this.newCustomCountries?.length) return '-';
    const match = this.newCustomCountries.find(
      (c: any) => c.isoCode === code || c.code === code,
    );
    return match?.countryName ?? code;
  }
  get countryRegionLabel(): string {
    const code = this.submittedData?.stateGroup; // e.g. "SA"
    if (!code || !this.countriesLists?.length) return '-';
    const match = this.countriesLists.find(
      (c: any) =>
        c.isoCode === code || c.code === code || c.countryName === code,
    );
    return match?.countryName ?? code;
  }
  private _filter(
    opt: { name: string; code: string }[],
    value: string,
  ): { name: string; code: string }[] {
    const filterValue = value.toLowerCase();
    return opt.filter((item) => item.name.toLowerCase().includes(filterValue));
  }
  displayFn = (option: { name: string; code: string } | null): string => {
    this.Setcity(option?.code || '', '');
    this.filteredcountries1 = option;
    return option ? option.name : '';
  };
  Setcity(countrycode: any, city: any) {
    if (countrycode) {
      this.registrationUtility.getCities(countrycode, city).subscribe(
        (cities) => {
          this.filteredCities = cities;
          this.noResultsFound = cities.length === 0;
        },
        (error) => {
          console.error('Error fetching city data', error);
          this.noResultsFound = true;
          this.filteredCities = [];
        },
      );
    }
  }
  selectFirstOption(type: 'country' | 'city') {
    if (type === 'country') {
      this.stateGroupOptions.subscribe((groups) => {
        if (groups.length > 0 && groups[0].names.length > 0) {
          const firstCountry = groups[0].names[0]; // Get the first country
          // this.stateForm.get('stateGroup')?.setValue(firstCountry);
          this.onOptionSelected({
            option: { value: firstCountry },
          } as MatAutocompleteSelectedEvent);
        }
      });
    } else if (type === 'city') {
      if (this.filteredCities.length > 0) {
        const firstCity = this.filteredCities[0]; // Get the first city
        this.corporateForm.get('cityControl')?.setValue(firstCity.cityName);
      }
    }
  }
  showCorporateInfoForm() {
    this._DataLayerService.onCorporateTravel_info_edit('Company Edit'); //GTM use
    // Emit the event to the parent component
    this._StepperService.RegstrationStepper('Corporate');
    this.editClicked.emit();
  }
  updateRegistrationIdValidators(countryCode: string) {
    const registrationIdControl = this.corporateForm.get('registrationId');
    const buildingControl = this.corporateForm.get('BuildingNo');
    const districtControl = this.corporateForm.get('district');
    const taxIdControl = this.corporateForm.get('taxIdentifcationNo');

    try {
      if (countryCode === 'SA') {
        this.message = '';

        registrationIdControl?.setValidators([
          Validators.required,
          Validators.pattern(/^\d{10}$/),
        ]);

        buildingControl?.setValidators([
          Validators.required,
          Validators.pattern(/^\d{4}$/)
        ]);

        districtControl?.setValidators([
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(150)
        ]);

        // ✅ ADD THIS
        taxIdControl?.setValidators([
          Validators.required,
          Validators.minLength(9),
          Validators.maxLength(15),
          Validators.pattern(/^[0-9]*$/)
        ]);

      } else {
        this.message = '(Optional)';

        registrationIdControl?.setValidators([
          Validators.minLength(8),
          Validators.maxLength(15),
        ]);

        taxIdControl?.setValidators([
          Validators.minLength(8),
          Validators.maxLength(15),
        ]);

        buildingControl?.setValidators([
          Validators.maxLength(15),
        ]);

        districtControl?.setValidators([
          Validators.minLength(5),
          Validators.maxLength(150),
        ]);

      }

      // ✅ Update all controls
      registrationIdControl?.updateValueAndValidity();
      buildingControl?.updateValueAndValidity();
      districtControl?.updateValueAndValidity();
      taxIdControl?.updateValueAndValidity();

    } catch (error) {
      console.error('Error updating validators:', error);
    }
  }
  onCityInput(event: Event): void {
    this.isCityDirty = true;
    const input = (event.target as HTMLInputElement).value;
    if (input !== this.PreviousCity) {
      this.corporateForm.get('cityControl')?.setErrors({ InvalidInput: true });
      this.corporateForm.setErrors({ cityInvalid: true });
      this.corporateForm.get('cityControl')?.markAsTouched();
      this.corporateForm.get('cityControl')?.markAsDirty();
    } else {
      this.corporateForm.get('cityControl')?.setErrors(null);
      this.corporateForm.get('cityControl')?.markAsUntouched();
    }
    const stateGroupControl = this.stateForm.get('stateGroup');
    if (stateGroupControl && stateGroupControl.value) {
      const countryCode = (this.stateForm.get('stateGroup')?.value as any).code;
      if (input.length >= 1 && countryCode) {
        if (countryCode) {
          this.registrationUtility.getCities(countryCode, input).subscribe(
            (cities) => {
              this.filteredCities = cities;
              this.noResultsFound = cities.length === 0;
            },
            (error) => {
              console.error('Error fetching city data', error);
              this.noResultsFound = true;
            },
          );
        } else {
          this.filteredCities = [];
          this.noResultsFound = true;
          this.corporateForm.get('city')?.setErrors({ noResults: true });
        }
      } else {
        this.filteredCities = [];
        this.noResultsFound = true;
        this.corporateForm.get('city')?.setErrors({ noResults: true });
      }
    }
  }
  onCitySelected(city: City) {
    this.selectedCity = city;
    this.corporateForm.get('city')?.setValue(city.cityCode);
    this.corporateForm.get('cityControl')?.setValue(city.cityName);
    this.PreviousCity = city.cityName;
    this.PreviousCityCode = city.cityCode;
  }
  onNGSelectCitySelected(event: City) {
    this.selectedCity = event.cityName;
    // this.corporateForm.get('city')?.setValue(city.cityCode);
    this.corporateForm.get('cityControl')?.setValue(event.cityName);
    // this.PreviousCity = city.cityName;
    // this.PreviousCityCode = city.cityCode;
  }
  onNGSelectCountrySelected(event: City) {
    if (!event) {
      this.corporateForm.get('city')?.setValue(null);
      this.filteredCities = [];
      this.corporateForm.get('city')?.updateValueAndValidity();
      //   this.corporateForm.get('registrationId')?.updateValueAndValidity();
    }
  }
  companyDetailForGTM(formData: any) {
    console.log('form data ', formData);
    let companyDetail = {
      country: this.getCountryNameFromCode(formData?.stateGroup),
      name: formData?.companyName,
      id: formData?.registrationId
    }
    return companyDetail;
  }
  onSubmit() {
    try {
      //get access token before login
      this.authService.getTokenbeforeLogin().subscribe((res: any) => {
        const tokenData = res.data;
        localStorage.setItem('token_type', tokenData.token_type);
        localStorage.setItem('access_token', tokenData.access_token);
        localStorage.setItem('expires_in', tokenData.expires_in);
        localStorage.setItem('session_id', tokenData.session_id);
        localStorage.setItem('scope', tokenData.scope);
      });
      if (
        this.corporateForm.valid &&
        this.stateForm.valid &&
        this.corporateForm.get('cityControl')?.valid
      ) {
        // Use getRawValue() to get all form values including disabled fields
        // This ensures all user changes (including edits after clicking Edit button) are captured in the payload
        const corporateFormValue = this.corporateForm.getRawValue();
        const stateFormValue = this.stateForm.value;
        const combinedFormValue = {
          ...corporateFormValue,
          ...stateFormValue, // <-- brings in stateGroup
        };
        // Update submittedData with current form values (including any edits)
        this.submittedData = combinedFormValue;
        // Update PreviousCountry for summary display
        const stateGroupValue = stateFormValue?.stateGroup as any;
        if (stateGroupValue) {
          const selectedCountry = this.newCustomCountries?.find(
            (item: any) => item.isoCode === stateGroupValue
          );

          this.PreviousCountry = selectedCountry?.countryName || '';
        }
        // Update selectedCity for summary display
        if (corporateFormValue.cityControl) {
          this.selectedCity = corporateFormValue.cityControl;
        }
        this.Shub = false;
        this.EditLink = false;
        this.showForm = false;
        this.CorporateHeading = false;
        // Emit the updated data to parent component
        this.CorporateInfo.emit(combinedFormValue);
        console.log('combined data ', combinedFormValue);
        sessionStorage.setItem('CD', combinedFormValue?.hasCompanyDomain);
        this._DataLayerService.signup_save_continue(
          this.companyDetailForGTM(combinedFormValue),
          'Company Details Page',
          'Corporate Registration Page'
        ); // GTM use
      }
    } catch (error: any) {
      this._DataLayerService.singup_save_continue_error(error?.error); //GTM use
    }
  }
  displayFn1(state: State | null): string {
    return state ? state.name : '';
  }
  // setupCompanyCheckDebounce(): void {
  //   this.companyCheckSubject
  //     .pipe(
  //       debounceTime(500), // Wait 500ms after last keystroke
  //       distinctUntilChanged(), // Only emit if value changed
  //       takeUntil(this.destroy$), // Clean up on component destroy
  //     )
  //     .subscribe((companyName) => {
  //       this.performCompanyCheck(companyName);
  //     });
  // }
  CheckCompany(event: any, flag: string = 'NAME'): void {

    const value = event.target.value.trim();
    const selectedCountry = this.stateForm.get('stateGroup')?.value;

    // ✅ Condition: Value + Country both required
    if (!value || !selectedCountry) {
      return; // Do not call API
    }

    if (flag === 'NAME' && value.length < 4) return;
    if (flag === 'REGISTRATIONID' && value.length < 8) return;
    if (flag === 'TAX' && value.length < 8) return;

    this.performCompanyCheck(value, selectedCountry, flag);
  }
  private performCompanyCheck(value: string, countryCode: string, flag: string): void {
    this.registrationUtility
      .CheckCompany(value, countryCode, flag)
      .subscribe({
        next: (exists) => {
          let controlName = 'companyName';
          if (flag === 'REGISTRATIONID') controlName = 'registrationId';
          if (flag === 'TAX') controlName = 'taxIdentifcationNo';

          const control = this.corporateForm.get(controlName);

          if (exists) {
            control?.setErrors({
              ...(control.errors || {}),
              CompanyExists: true,
            });
          } else {
            const errors = control?.errors || {};
            delete errors['CompanyExists'];
            control?.setErrors(Object.keys(errors).length ? errors : null);
          }
        },
        error: (err) => {
          console.error('Company check error', err);
        },
      });
  }
  blockInvalidUrl(event: KeyboardEvent): void {
    // List of individual characters considered unsafe for XSS, SQL Injection, or path traversal
    const invalidChars = ['<', '>', '"', "'", '`', ';', '\\', '?', '+', '#', '%', '^', '*', '!', '=', '(', ')', '{', '}', '|', '&',];
    // A simple regex to prevent sequences like '--', '/*' (for SQL Injection or comments in code)
    const forbiddenRegex = /--|\/\*|\*\/|;|<|>|['"]/g;
    // Allow characters for valid URLs like "https://", "www", ".", and "/" etc.
    const validUrlChars = /[a-zA-Z0-9\-\.\/\:\?&=]/;
    // Check if the key pressed is in the invalidChars array
    if (invalidChars.includes(event.key)) {
      event.preventDefault();
      return;
    }
    // Check if the input is in a field that expects a URL
    const inputElement = event.target as HTMLInputElement;
    // Allow the initial 'https://' part for valid URLs
    if (inputElement && inputElement.value.startsWith('https://')) {
      // For URLs starting with https://, allow characters like "." and "/"
      if (!validUrlChars.test(event.key)) {
        event.preventDefault();
      }
      return;
    }
    // Check if the current input value (including the new key) matches the forbidden regex
    if (inputElement && forbiddenRegex.test(inputElement.value + event.key)) {
      event.preventDefault();
    }
    if ((inputElement && inputElement.value.endsWith('.com')) || '.in') {
      // For URLs starting with https://, allow characters like "." and "/"
      if (!validUrlChars.test(event.key)) {
        event.preventDefault();
      }
      return;
    }
  }
  headOfcValidation(event: KeyboardEvent): void {
    const allowedPattern = /^[a-zA-Z0-9 ,.\-&#\/]$/;
    if (!allowedPattern.test(event.key)) {
      event.preventDefault();
    }
  }
  inputFieldValidation(event: KeyboardEvent, controlName: string): void {
    if (controlName === 'headOfficeAddress') {
      if (!/^[a-zA-Z0-9 ,.\-&#/]$/.test(event.key)) {
        event.preventDefault();
      }
      return;
    }

    if (controlName === 'companyUrl') {
      if (!/^[a-zA-Z0-9\-_.~:/?#\[\]@!$&'()*+,;=]$/.test(event.key)) {
        event.preventDefault();
      }
    }
  }
  getSiteCoreArray(keyString: string): Array<any> {
    return this.content?.[keyString];
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  trimField(field: string) {
    const control = this.corporateForm.get(field);
    if (control?.value) {
      control.setValue(control.value.trim());
    }
  }
}
